import React from 'react';
import { Button } from '@mui/material';
/**
 * A custom React component for a button representing 800 GB of mass memory.
 *
 * @param {Object} props - The component props.
 * @param {string} props.text - The text to display on the button. Defaults to '800 GB'.
 * @param {string} props.variant - The variant of the button. Defaults to 'outlined'.
 * @param {string} props.color - The color of the button. Defaults to 'primary'.
 * @param {Function} props.onClick - The function to call when the button is clicked.
 *
 */
const MassMemory800gb = ({ text, variant, color, onClick }) => {
  return (
    <Button
      size="small"
      variant={variant || 'outlined'}
      color={color || 'primary'}
      onClick={() => onClick(800)}
      sx={{
        fontFamily: 'Open Sans',
        color: '#363636',
        width: { xs: '100%', sm: '100%', md: '90%' },
        height: { xs: 'auto', sm: '40px' },
        padding: '10px 20px',
        margin: '0 10px',
        textTransform: 'none',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflow: 'hidden',
        fontSize: '16px'
      }}
    >
      {text || '800 GB'}
    </Button>
  )
}

export default MassMemory800gb;